/* DS-REVIEWS v1 (2026-10-17) — behaviour for sections/ds-reviews.liquid.
   One module owns the widget: sort, rating filter, show-more, masonry columns, the review
   quick view, and the write-a-review flow (posts to the section's submission endpoint). */
(function () {
  'use strict';
  if (window.__dsReviewsBooted) return;
  window.__dsReviewsBooted = true;

  var SORTS = {
    featured: function (a, b) { return a.idx - b.idx; },
    newest: function (a, b) { return (b.ts - a.ts) || (a.idx - b.idx); },
    highest: function (a, b) { return (b.rating - a.rating) || (b.ts - a.ts) || (a.idx - b.idx); },
    lowest: function (a, b) { return (a.rating - b.rating) || (b.ts - a.ts) || (a.idx - b.idx); }
  };

  /* old widget's breakpoints, measured on the widget's own width */
  function colsFor(w) {
    if (w >= 1150) return 5;
    if (w >= 920) return 4;
    if (w >= 480) return 3;
    if (w >= 320) return 2;
    return 1;
  }

  var openModal = null, lastFocus = null;

  function lock(on) { document.documentElement.classList.toggle('ds-rv-locked', !!on); }

  function focusables(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not(.ds-rv-hp),textarea,select,[tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null || n === document.activeElement; });
  }

  function showModal(m, focusEl) {
    lastFocus = document.activeElement;
    m.hidden = false;
    openModal = m;
    lock(true);
    var p = m.querySelector('[role="dialog"]');
    (focusEl || p).focus({ preventScroll: true });
  }

  function hideModal() {
    if (!openModal) return;
    var m = openModal;
    m.hidden = true;
    openModal = null;
    lock(false);
    m.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (m._onClose) m._onClose();
  }

  document.addEventListener('keydown', function (e) {
    if (!openModal) return;
    if (e.key === 'Escape') { e.preventDefault(); var pol = openModal.querySelector('[data-rv-policy]:not([hidden])'); if (pol) { pol.hidden = true; return; } hideModal(); return; }
    if (e.key === 'Tab') {
      var f = focusables(openModal.querySelector('[role="dialog"]'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) hideModal(); });

  function fmtDate(iso, locale) {
    if (!iso) return '';
    var p = iso.split('-');
    var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    try {
      var loc = (!locale || locale === 'en') ? 'en-US' : locale;
      return new Intl.DateTimeFormat(loc, { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' }).format(d);
    } catch (e) { return iso; }
  }

  function Widget(root) {
    this.root = root;
    this.grid = root.querySelector('[data-rv-grid]');
    this.more = root.querySelector('[data-rv-more]');
    this.perPage = parseInt(root.getAttribute('data-per-page'), 10) || 20;
    this.sort = root.getAttribute('data-sort') || 'highest';
    this.mediaFirst = root.getAttribute('data-media-first') !== 'false';
    this.filter = 0;
    this.shown = this.perPage;
    this.locale = root.getAttribute('data-locale') || 'en';
    this.i18n = {};
    try { this.i18n = JSON.parse(root.querySelector('[data-rv-i18n]').textContent); } catch (e) {}
    this.items = [];
    var self = this;
    if (this.grid) {
      this.grid.querySelectorAll('[data-rv-item]').forEach(function (el) {
        self.items.push({ el: el, idx: +el.getAttribute('data-idx'), rating: +el.getAttribute('data-rating'), ts: +el.getAttribute('data-ts') || 0, media: el.classList.contains('has-media') ? 1 : 0 });
      });
    }
    root.querySelectorAll('[data-rv-date]').forEach(function (d) { d.textContent = fmtDate(d.getAttribute('data-rv-date'), self.locale); });
    this.bind();
    this.render();
    if (this.grid && 'ResizeObserver' in window) {
      var lastCols = 0;
      new ResizeObserver(function () {
        var c = self.cols();
        if (c !== lastCols) { lastCols = c; self.layout(); }
      }).observe(root.querySelector('.ds-rv__wrap'));
    }
    root.querySelectorAll('.ds-rv__img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { self.layout(); }, { once: true });
    });
  }

  Widget.prototype.cols = function () {
    var wrap = this.root.querySelector('.ds-rv__wrap');
    var cs = getComputedStyle(wrap);
    var w = wrap.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    return colsFor(w);
  };

  Widget.prototype.visible = function () {
    var f = this.filter;
    var list = this.items.filter(function (it) { return !f || it.rating === f; });
    var by = SORTS[this.sort] || SORTS.highest, mf = this.mediaFirst;
    list.sort(function (a, b) { return (mf ? b.media - a.media : 0) || by(a, b); });
    return list;
  };

  Widget.prototype.render = function () {
    if (!this.grid) return;
    var list = this.visible();
    var show = list.slice(0, this.shown);
    this.items.forEach(function (it) { it.el.hidden = true; });
    show.forEach(function (it) { it.el.hidden = false; });
    this.order = show;
    if (this.more) this.more.hidden = list.length <= this.shown;
    this.layout();
  };

  /* masonry: each card goes to the currently shortest column, in display order (as the old widget) */
  Widget.prototype.layout = function () {
    if (!this.grid || !this.order) return;
    var n = this.cols();
    var g = this.grid;
    g.style.setProperty('--rv-cols', n);
    var cols = [];
    var hidden = this.items.filter(function (it) { return it.el.hidden; });
    g.classList.add('is-masonry');
    g.querySelectorAll('.ds-rv__col').forEach(function (c) { c.remove(); });
    for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'ds-rv__col'; g.appendChild(c); cols.push({ el: c, h: 0 }); }
    this.order.forEach(function (it) {
      var best = cols[0];
      for (var j = 1; j < cols.length; j++) if (cols[j].h < best.h - 0.5) best = cols[j];
      best.el.appendChild(it.el);
      best.h += it.el.offsetHeight;
    });
    hidden.forEach(function (it) { g.appendChild(it.el); });
  };

  Widget.prototype.closePanels = function (except) {
    var r = this.root;
    var dist = r.querySelector('[data-rv-dist]'), dt = r.querySelector('[data-rv-dist-toggle]');
    var menu = r.querySelector('[data-rv-sort-menu]'), mt = r.querySelector('[data-rv-sort-toggle]');
    if (dist && except !== 'dist') { dist.hidden = true; dt.setAttribute('aria-expanded', 'false'); }
    if (menu && except !== 'sort') { menu.hidden = true; mt.setAttribute('aria-expanded', 'false'); }
  };

  Widget.prototype.bind = function () {
    var self = this, r = this.root;
    var dt = r.querySelector('[data-rv-dist-toggle]'), dist = r.querySelector('[data-rv-dist]');
    var mt = r.querySelector('[data-rv-sort-toggle]'), menu = r.querySelector('[data-rv-sort-menu]');
    if (dt && dist) dt.addEventListener('click', function (e) {
      e.stopPropagation(); var open = dist.hidden; self.closePanels('dist');
      dist.hidden = !open; dt.setAttribute('aria-expanded', String(open));
    });
    if (mt && menu) mt.addEventListener('click', function (e) {
      e.stopPropagation(); var open = menu.hidden; self.closePanels('sort');
      menu.hidden = !open; mt.setAttribute('aria-expanded', String(open));
    });
    [dist, menu].forEach(function (p) { if (p) p.addEventListener('click', function (e) { e.stopPropagation(); }); });
    document.addEventListener('click', function () { self.closePanels(); });
    r.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !openModal) self.closePanels(); });

    r.querySelectorAll('[data-rv-sort]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.sort = b.getAttribute('data-rv-sort');
        r.querySelectorAll('[data-rv-sort]').forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
        self.shown = self.perPage; self.render(); self.closePanels();
      });
    });
    r.querySelectorAll('[data-rv-rating]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = +b.getAttribute('data-rv-rating');
        self.filter = self.filter === v ? 0 : v;
        r.querySelectorAll('[data-rv-rating]').forEach(function (x) { x.setAttribute('aria-pressed', String(+x.getAttribute('data-rv-rating') === self.filter)); });
        self.shown = self.perPage; self.render(); self.closePanels();
      });
    });
    /* Show more is display-only (Giuseppe 2026-10-17): the button stays, clicking does nothing. */

    var popup = r.getAttribute('data-popup') === 'true';
    if (this.grid && popup) this.grid.addEventListener('click', function (e) {
      var card = e.target.closest('.ds-rv__card'); if (card) self.openReview(card.parentNode);
    });
    if (this.grid && popup) this.grid.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('ds-rv__card')) { e.preventDefault(); self.openReview(e.target.parentNode); }
    });

    var qv = r.querySelector('[data-rv-qv]');
    if (qv) {
      document.body.appendChild(qv); /* overlays live at root level (R-06) */
      this.qv = qv;
      qv.querySelectorAll('[data-rv-close]').forEach(function (b) { b.addEventListener('click', hideModal); });
      var info = qv.querySelector('[data-rv-info]'), note = qv.querySelector('[data-rv-note]');
      info.addEventListener('click', function (e) { e.stopPropagation(); note.hidden = !note.hidden; info.setAttribute('aria-expanded', String(!note.hidden)); });
      qv.querySelector('[data-rv-policy-open]').addEventListener('click', function () { qv.querySelector('[data-rv-policy]').hidden = false; qv.querySelector('[data-rv-policy-close]').focus(); });
      qv.querySelector('[data-rv-policy-close]').addEventListener('click', function () { qv.querySelector('[data-rv-policy]').hidden = true; info.focus(); });
      qv._onClose = function () { note.hidden = true; info.setAttribute('aria-expanded', 'false'); qv.querySelector('[data-rv-policy]').hidden = true; };
      copyVars(r, qv);
    }
    var wr = r.querySelector('[data-rv-wr]');
    if (wr) {
      document.body.appendChild(wr);
      copyVars(r, wr);
      this.wr = new WriteFlow(wr, r, this.i18n);
      /* Write a review is display-only: the button stays, clicking does nothing (Giuseppe 2026-10-17). */
    }
  };

  function copyVars(from, to) {
    var cs = getComputedStyle(from);
    ['--rv-font', '--rv-star', '--rv-star-empty', '--rv-overlay', '--rv-primary', '--rv-primary-text', '--rv-text'].forEach(function (k) {
      var v = cs.getPropertyValue(k); if (v) to.style.setProperty(k, v.trim());
    });
  }

  Widget.prototype.openReview = function (item) {
    var qv = this.qv; if (!qv) return;
    var card = item.querySelector('.ds-rv__card');
    var tpl = item.querySelector('template[data-rv-full]');
    var media = qv.querySelector('[data-rv-qv-media]');
    media.innerHTML = '';
    var notes = [];
    if (tpl) {
      var frag = tpl.content.cloneNode(true);
      frag.querySelectorAll('[data-v-note]').forEach(function (n) { notes.push(n.textContent); n.remove(); });
      media.appendChild(frag);
    }
    media.querySelectorAll('img').forEach(function (i) { i.loading = 'eager'; });
    var panel = qv.querySelector('.ds-rv-qv__panel');
    panel.classList.toggle('no-media', !media.children.length);
    qv.querySelector('[data-rv-qv-name]').textContent = card.querySelector('.ds-rv__author').textContent;
    var stars = card.querySelector('.ds-rv__stars .ds-rv-stars');
    var sh = qv.querySelector('[data-rv-qv-stars]'); sh.innerHTML = ''; if (stars) sh.appendChild(stars.cloneNode(true));
    var d = card.querySelector('.ds-rv__date');
    qv.querySelector('[data-rv-qv-date]').textContent = d ? d.textContent : '';
    var t = card.querySelector('.ds-rv__text');
    qv.querySelector('[data-rv-qv-text]').textContent = t ? t.innerText : '';
    var mv = card.querySelector('.ds-rv__meta-value'), meta = qv.querySelector('[data-rv-qv-meta]');
    meta.innerHTML = '';
    if (mv) {
      var l = document.createElement('div'); l.className = 'l'; l.textContent = this.i18n.itemType || '';
      var v = document.createElement('div'); v.className = 'v'; v.textContent = mv.textContent;
      meta.appendChild(l); meta.appendChild(v);
    }
    var isVer = !!card.querySelector('.ds-rv__verified');
    qv.querySelector('[data-rv-qv-verified]').hidden = !isVer;
    var nt = qv.querySelector('[data-rv-note-text]'); nt.innerHTML = '';
    notes.forEach(function (s) { var p = document.createElement('p'); p.textContent = s; nt.appendChild(p); });
    showModal(qv, qv.querySelector('[data-rv-close].ds-rv-modal__x'));
  };

  /* ---------- write a review ---------- */
  var MAX_PHOTOS = 5, MAX_PHOTO = 15 * 1024 * 1024, MAX_VIDEO = 250 * 1024 * 1024;

  function WriteFlow(m, root, i18n) {
    this.m = m; this.root = root; this.i18n = i18n;
    this.form = m.querySelector('[data-rv-form]');
    this.endpoint = root.getAttribute('data-endpoint');
    this.photos = []; this.video = null; this.rating = 0;
    var self = this;
    m.querySelectorAll('[data-rv-wr-close]').forEach(function (b) { b.addEventListener('click', hideModal); });
    m.querySelectorAll('[data-rv-pick]').forEach(function (b) {
      b.addEventListener('click', function () { self.setRating(+b.getAttribute('data-rv-pick')); self.go('media'); });
      b.addEventListener('mouseenter', function () { self.paintStars(+b.getAttribute('data-rv-pick')); });
      b.addEventListener('mouseleave', function () { self.paintStars(self.rating); });
    });
    m.querySelectorAll('[data-rv-back]').forEach(function (b) { b.addEventListener('click', function () { self.back(); }); });
    m.querySelectorAll('[data-rv-next]').forEach(function (b) { b.addEventListener('click', function () { self.next(); }); });
    this.body = m.querySelector('[data-rv-body]');
    this.body.addEventListener('input', function () { m.querySelector('[data-step="text"] [data-rv-next]').disabled = !self.body.value.trim(); });
    m.querySelector('[data-rv-photos]').addEventListener('change', function (e) { self.addPhotos(e.target.files); e.target.value = ''; });
    m.querySelector('[data-rv-video]').addEventListener('change', function (e) { self.setVideo(e.target.files[0]); e.target.value = ''; });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    this.form.querySelectorAll('input[name]').forEach(function (inp) { inp.addEventListener('input', function () { var er = self.form.querySelector('[data-err="' + inp.name + '"]'); if (er) er.textContent = ''; }); });
  }
  WriteFlow.prototype.steps = ['rate', 'media', 'text', 'about', 'thanks'];
  WriteFlow.prototype.open = function () {
    this.reset();
    showModal(this.m, this.m.querySelector('[data-rv-pick="5"]'));
  };
  WriteFlow.prototype.reset = function () {
    this.form.reset(); this.photos = []; this.video = null; this.rating = 0; this.paintStars(0);
    this.renderThumbs(); this.m.querySelector('[data-rv-submit-err]').textContent = '';
    this.m.querySelector('[data-rv-media-err]').textContent = '';
    this.m.querySelector('[data-step="text"] [data-rv-next]').disabled = true;
    this.form.querySelectorAll('[data-err]').forEach(function (e) { e.textContent = ''; });
    this.go('rate');
  };
  WriteFlow.prototype.go = function (name) {
    this.cur = name;
    this.form.setAttribute('data-cur', name);
    this.m.querySelectorAll('.ds-rv-wr__step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
    var s = this.m.querySelector('[data-step="' + name + '"]');
    var f = s.querySelector('textarea,input:not(.ds-rv-hp),[data-rv-pick],.ds-rv-wr__cta');
    if (name === 'text') this.body.placeholder = this.rating && this.rating <= 2 ? this.body.getAttribute('data-ph-low') : this.body.getAttribute('data-ph');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 0);
  };
  WriteFlow.prototype.next = function () { var i = this.steps.indexOf(this.cur); this.go(this.steps[i + 1]); };
  WriteFlow.prototype.back = function () { var i = this.steps.indexOf(this.cur); this.go(this.steps[Math.max(0, i - 1)]); };
  WriteFlow.prototype.setRating = function (n) {
    this.rating = n; this.paintStars(n);
    this.m.querySelectorAll('[data-rv-pick]').forEach(function (b) { b.setAttribute('aria-checked', String(+b.getAttribute('data-rv-pick') === n)); });
  };
  WriteFlow.prototype.paintStars = function (n) {
    this.m.querySelectorAll('[data-rv-pick] .ds-rv-star').forEach(function (s, i) { s.setAttribute('data-fill', i < n ? 'full' : 'empty'); });
  };
  WriteFlow.prototype.addPhotos = function (files) {
    var err = this.m.querySelector('[data-rv-media-err]'); err.textContent = '';
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      if (this.photos.length >= MAX_PHOTOS) { err.textContent = this.i18n.maxPhotos || ''; break; }
      if (f.size > MAX_PHOTO) { err.textContent = this.i18n.photoSize || ''; continue; }
      this.photos.push(f);
    }
    this.renderThumbs();
  };
  WriteFlow.prototype.setVideo = function (f) {
    var err = this.m.querySelector('[data-rv-media-err]'); err.textContent = '';
    if (!f) return;
    if (f.size > MAX_VIDEO) { err.textContent = this.i18n.videoSize || ''; return; }
    this.video = f; this.renderThumbs();
  };
  WriteFlow.prototype.renderThumbs = function () {
    var box = this.m.querySelector('[data-rv-thumbs]'), self = this;
    box.querySelectorAll('img,video').forEach(function (e) { if (e.src) URL.revokeObjectURL(e.src); });
    box.innerHTML = '';
    var all = this.photos.map(function (f) { return { f: f, kind: 'img' }; });
    if (this.video) all.push({ f: this.video, kind: 'video' });
    all.forEach(function (o) {
      var fig = document.createElement('figure');
      var el = document.createElement(o.kind === 'img' ? 'img' : 'video');
      el.src = URL.createObjectURL(o.f); if (o.kind === 'video') el.muted = true; else el.alt = '';
      var x = document.createElement('button'); x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', 'Remove');
      x.addEventListener('click', function () {
        if (o.kind === 'img') self.photos.splice(self.photos.indexOf(o.f), 1); else self.video = null;
        self.renderThumbs();
      });
      fig.appendChild(el); fig.appendChild(x); box.appendChild(fig);
    });
  };
  WriteFlow.prototype.submit = function () {
    var f = this.form, i18n = this.i18n, ok = true;
    var first = f.elements.first_name, email = f.elements.email;
    var e1 = f.querySelector('[data-err="first_name"]'), e2 = f.querySelector('[data-err="email"]');
    e1.textContent = ''; e2.textContent = '';
    if (!first.value.trim()) { e1.textContent = i18n.required || ''; ok = false; }
    if (!email.value.trim()) { e2.textContent = i18n.required || ''; ok = false; }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { e2.textContent = i18n.badEmail || ''; ok = false; }
    if (!ok) { (first.value.trim() ? email : first).focus(); return; }
    var btn = f.querySelector('[data-rv-submit]'), err = f.querySelector('[data-rv-submit-err]');
    err.textContent = '';
    var label = btn.textContent;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = i18n.sending || label;
    var fd = new FormData();
    fd.append('product_id', this.root.getAttribute('data-product-id'));
    fd.append('product_title', this.root.getAttribute('data-product-title') || '');
    fd.append('rating', String(this.rating));
    fd.append('body', this.body.value.trim());
    fd.append('first_name', first.value.trim());
    fd.append('last_name', f.elements.last_name.value.trim());
    fd.append('email', email.value.trim());
    fd.append('website', f.elements.website.value);
    fd.append('locale', this.root.getAttribute('data-locale') || '');
    fd.append('page', location.href.split('?')[0]);
    this.photos.forEach(function (p) { fd.append('photos', p, p.name); });
    if (this.video) fd.append('video', this.video, this.video.name);
    var self = this;
    fetch(this.endpoint, { method: 'POST', body: fd, mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || ('HTTP ' + r.status)); return j; }); })
      .then(function () { self.go('thanks'); })
      .catch(function () { err.textContent = i18n.failed || ''; })
      .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label; });
  };

  function boot() { document.querySelectorAll('[data-ds-reviews]').forEach(function (r) { if (!r.__dsrv) r.__dsrv = new Widget(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
